"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _ = require("./..");

var _Layers = _interopRequireDefault(require("../../ui/Layers"));

var _GlobalComponentsContext = require("../../global/GlobalComponentsContext");

var _GlobalErrorBoundary = _interopRequireDefault(require("../../global/GlobalErrorBoundary"));

var Router = function Router(_ref) {
  var children = _ref.children,
      routes = _ref.routes,
      menu = _ref.menu,
      basename = _ref.basename;

  var _useGlobalComponents = (0, _GlobalComponentsContext.useGlobalComponents)(),
      RouterLayout = _useGlobalComponents.RouterLayout;

  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.BrowserRouter, {
    basename: basename
  }, /*#__PURE__*/_react.default.createElement(_GlobalErrorBoundary.default, null, /*#__PURE__*/_react.default.createElement(RouterLayout, {
    menu: menu
  }, /*#__PURE__*/_react.default.createElement(_.Switch, null, routes.map(function (props, index) {
    return /*#__PURE__*/_react.default.createElement(_.Route, (0, _extends2.default)({
      key: index
    }, props));
  }))), children, /*#__PURE__*/_react.default.createElement(_Layers.default, null)));
};

Router.displayName = 'Router';
Router.propTypes = {
  children: _propTypes.default.node,
  routes: _propTypes.default.array,
  menu: _propTypes.default.array,
  RouterLayout: _propTypes.default.elementType,
  ErrorHandler: _propTypes.default.elementType,
  basename: _propTypes.default.string
};
var _default = Router;
exports.default = _default;